import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { ProjectModel } from './model/project/project.model';
import { ProjectDashboardService } from '../shared/services/project.dashboard.service';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { HomeService } from '../shared/services/home.service';
import { MatSidenav } from '@angular/material/sidenav';
import { NotifierService } from 'angular-notifier';

interface ProjectDetails{
  name:string;
  id:string;
  status:string;
  org:string;
  org_uuid:string;
}
@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  @ViewChild('sidenav2') sidenavRef: MatSidenav;

  project$: ProjectModel;
  projectDetails:ProjectDetails;
  status$: string;
  status_message$: string;
  showLoader: boolean;
  noData: any;
  accessRole:any;
  errorText: any;
  originalData: any;
  showMask:boolean = false;
  isCreateProject:boolean = false;
  isUpdateProject:boolean = false;

  // scroll pagination
  throttle = 150;
  scrollDistance = 2;
  pageData = {pageNo: 1, pageLimit: 20, filters: 1};
  public projectsToShow: any;
  public scrollData:boolean = true;
  public isViewer:boolean = false;

  constructor(private projectDashbaord: ProjectDashboardService, 
    private router: Router,
    private notifier: NotifierService,
    private homeService: HomeService,
    private projectService:ProjectDashboardService,
    private logerror: LoginService) {
    this.showLoader = true;
    this.accessRole = JSON.parse(localStorage.getItem('access'));
    // console.log("this.accessRole,", this.accessRole)
    this.isViewer = this.accessRole.access_type && this.accessRole.access_type == 'viewer' ? true : false;
    this.homeService.isOpen = false;
  }

  updateAllNew(event:any){
    this.pageData['pageNo'] = 0;
    if(event === true){
      this.getProject();
    }else{
      this.sidenavRef.close();
    }
  }
  ngOnInit() {
    this.pageData['pageNo'] = 0;
    this.pageData['filters'] = 1;
    this.getProject();
  }

  filterData(type) {
    if (type === 'active') {
      // this.projectsToShow  = JSON.parse(JSON.stringify(this.originalData.result));
      // for ( let i = 0; i < this.projectsToShow.length; ++i) {
      //   // this.projectsToShow = this.projectsToShow.filter(item => item.project_details.project_status === "1");
      //
      // }
      this.pageData['pageNo'] = 0;
      this.pageData['filters'] = 2;
      this.getProject();
    }
    else if(type === 'inactive'){
      // this.projectsToShow  = JSON.parse(JSON.stringify(this.originalData.result));
      // for ( let i = 0; i < this.projectsToShow.length; ++i) {
      //   // this.projectsToShow = this.projectsToShow.filter(item => item.project_details.project_status === "0");
      //
      //
      // }
      this.pageData['pageNo'] = 0;
      this.pageData['filters'] = 3;
      this.getProject();
    }
    else{
      // this.projectsToShow = JSON.parse(JSON.stringify(this.originalData.result));
      this.pageData['pageNo'] = 0;
      this.pageData['filters'] = 1;
      this.getProject();
    }
    if(this.projectsToShow.length === 0) {
      this.errorText = 'There are no projects to show';
      this.noData = true;
      this.showLoader = false;
      this.showMask = false;
    }
    else {
      this.noData = false;
    }
  }


  projectList(item: string) {
    this.router.navigate(['/home/projects', item]);
    // this.router.navigate(['/home/dashboard'], { state: { projectId: item } });
  }

  onScrollProjects() {
    this.showMask = true;
      this.getProject();
  }
  onClose(sidenav2) {
    this.sidenavRef.toggle();
  }
  addProject(){
    console.log('addProject Clicked');
    this.isCreateProject = true;
    this.isUpdateProject = false;
    this.sidenavRef.open();
  }

  updateProject(projectDetail:any, organization:string){
    this.projectService.getAProjectDetails(projectDetail.id);
    this.projectDetails = {
      id : projectDetail.id,
      name:projectDetail.name,
      status : projectDetail.project_status,
      org:organization,
      org_uuid:projectDetail.org_uuid
    };
    // console.log(projectDetail);
    this.projectDetails.id = projectDetail.id;
    this.projectDetails.name = projectDetail.name;
    this.projectDetails.status = projectDetail.project_status;
    this.projectDetails.org = organization;
    this.isCreateProject = false;
    this.isUpdateProject = true;
    this.sidenavRef.open();
  }

  getProject() {
    this.pageData['pageNo']++;
    this.projectDashbaord.getPaginationProject(this.pageData).subscribe(data => {

      
        if (data.result.length !== 0 ) {
          this.project$ = data;
          if (this.pageData['pageNo'] > 1) {
            this.projectsToShow = [...this.projectsToShow, ...this.project$.result];
            this.showMask = false;
          } else {
            this.projectsToShow = this.project$.result;
          }
          this.originalData = data;
          this.noData = false;
          this.showLoader = false;
        } else if (this.pageData['pageNo'] === 1) {
            this.errorText = 'There are no projects to show';
            this.noData = true;
            this.showLoader = false;
            this.showMask = false;
          } else {
          this.showMask = false;
        }
      },
      error => { // error path
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.showLoader = false;
          this.noData = true;
          this.showMask = false;
          this.router.navigate(['home/access-denied']);
        }
        else {
          if (this.pageData['pageNo'] === 1) {
            this.errorText = 'Something went wrong';
            this.noData = true;
          }else{
            this.notifier.notify('error', 'Something went wrong');
          }
          this.showLoader = false;
          this.showMask = false;
        }
      }
    );
  }
}
